import BaseTransformer from "./base.transformer"

export const baseUri = "/api/qr-typologies"

function getInternalName(name) {
  return {
    "dashboard.content.none.label": "none",
    "dashboard.content.landing.label": "landing",
    "dashboard.content.smart.label": "smartpage",
    "dashboard.content.website.label": "website"
  }[name]
}

class QrTypologyTransformer extends BaseTransformer {
  static fetch(typology) {
    const uuid = this.transformUuid(typology)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      createdAt: typology.createdAt,
      internalName: getInternalName(typology.name),
      updatedAt: typology.updatedAt,
      name: typology.name
    })
  }
}

export default QrTypologyTransformer
